import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

/**
 * Wraps routes that require superadmin (Dawn's admin panel).
 * Non-admins are redirected to /dashboard, not /login.
 */
export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, userRole } = useAuthStore((s) => ({
    isAuthenticated: s.isAuthenticated,
    userRole: s.userRole,
  }));

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userRole !== 'superadmin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
